module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOCAxNCI+CjxwYXRoIGZpbGw9IndoaXRlIiBkPSJNNy40OTIgMC4wOTR2Mi4wNjJoLTEuMjI3cS0wLjY3MiAwLTAuOTA2IDAuMjgxdC0wLjIzNCAwLjg0NHYxLjQ3N2gyLjI4OWwtMC4zMDUgMi4zMTNoLTEuOTg0djUuOTNoLTIuMzkxdi01LjkzaC0xLjk5MnYtMi4zMTNoMS45OTJ2LTEuNzAzcTAtMS40NTMgMC44MTMtMi4yNTR0Mi4xNjQtMC44MDFxMS4xNDggMCAxLjc4MSAwLjA5NHoiPjwvcGF0aD4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.svg
// module id = 858
// module chunks = 0